var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item selectable-shop-item" }, [
    _c("div", { staticClass: "image" }, [
      _c("div", { staticClass: "ui bottom right attached green label" }, [
        _vm._v(_vm._s(_vm.shop.area_detail_label)),
      ]),
      _vm._v(" "),
      _c("img", {
        staticStyle: { "margin-bottom": "0 !important" },
        attrs: { src: _vm.shop.main_image.urls.medium_square },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c(
        "a",
        {
          staticClass: "header",
          attrs: { href: _vm.shop.shop_preview_url, target: "_blank" },
        },
        [
          _c(
            "div",
            {
              staticClass: "ui mini label",
              class: _vm.rankLabelClass(_vm.shop.rank),
            },
            [_vm._v(_vm._s(_vm.shop.rank_label))]
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.shop.name))]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "meta" }, [
        _c("p", [_vm._v("店舗電話番号：" + _vm._s(_vm.shop.tel))]),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shop.shop_type,
                expression: "shop.shop_type",
              },
            ],
          },
          [_vm._v("会場：" + _vm._s(_vm.shop.shop_type_label))]
        ),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n          最大宴会人数：\n          "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shop.max_count > 0,
                  expression: "shop.max_count > 0",
                },
              ],
            },
            [_vm._v("着席：〜" + _vm._s(_vm.shop.max_count) + "人")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shop.max_standing_count > 0,
                  expression: "shop.max_standing_count > 0",
                },
              ],
            },
            [_vm._v("立席：〜" + _vm._s(_vm.shop.max_standing_count) + "人")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shop.courses.length > 0,
                expression: "shop.courses.length > 0",
              },
            ],
          },
          [_vm._v("プラン：" + _vm._s(_vm.lowestPriceLabel(_vm.shop.courses)))]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shop.genres.length > 0,
                expression: "shop.genres.length > 0",
              },
            ],
          },
          _vm._l(_vm.shop.genre_labels, function (genre) {
            return _c("span", { key: genre, staticClass: "ui tiny label" }, [
              _vm._v(_vm._s(genre)),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "extra" }, [
        _vm.candidate
          ? _c(
              "div",
              {
                staticClass: "ui orange tiny button",
                on: {
                  click: function ($event) {
                    return _vm.showCandidateDetail()
                  },
                },
              },
              [_vm._v("立候補内容を確認")]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isSelected(_vm.shop)
          ? _c(
              "div",
              {
                staticClass: "ui green basic tiny button",
                on: {
                  click: function ($event) {
                    return _vm.select()
                  },
                },
              },
              [_vm._v("選択する")]
            )
          : _c(
              "div",
              {
                staticClass: "ui red tiny button",
                on: {
                  click: function ($event) {
                    return _vm.unselect()
                  },
                },
              },
              [_vm._v("選択を解除する")]
            ),
        _vm._v(" "),
        _vm.isSuggested()
          ? _c("div", { staticClass: "ui left pointing red basic label" }, [
              _vm._v("提案済み"),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.candidate
      ? _c(
          "div",
          { staticClass: "ui small modal", attrs: { id: _vm.dialogId } },
          [
            _c("i", { staticClass: "close icon" }),
            _vm._v(" "),
            _c("div", { staticClass: "header" }, [
              _vm._v(_vm._s(_vm.candidate.shop.name)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "scrolling content" },
              [_c("candidate-detail", { attrs: { candidate: _vm.candidate } })],
              1
            ),
            _vm._v(" "),
            _vm._m(0),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "actions" }, [
      _c("button", { staticClass: "ui cancel button" }, [_vm._v("閉じる")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }